import React from 'react';
import './Home.css';

const Home = () => {
    return (
        <div className="home" >
        <h1  className="home">Fitness Tracker</h1>
        <img className="home" src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80"></img>
    </div>
    )
}

export default Home;